import { render, staticRenderFns } from "./SettingsPage.vue?vue&type=template&id=ac7d2b34&scoped=true"
import script from "./SettingsPage.vue?vue&type=script&lang=ts"
export * from "./SettingsPage.vue?vue&type=script&lang=ts"
import style0 from "./SettingsPage.vue?vue&type=style&index=0&id=ac7d2b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7d2b34",
  null
  
)

export default component.exports